import React, { useState, useEffect } from "react";
import axios from "axios";
import PricingTable from "./PricingTable";
import { useNavigate } from "react-router-dom";
import "./css/ManageSubscription.css"; // Import the CSS file

const API_URL =
  "https://lykns00a87.execute-api.us-east-2.amazonaws.com/default/football_app_data_crud";

const ManageSubscription = ({ userId }) => {
  const [currentPlan, setCurrentPlan] = useState(null);
  const [freeTierUsed, setFreeTierUsed] = useState(false);
  const [gamesLeft, setGamesLeft] = useState(0);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      try {
        const response = await axios.post(API_URL, {
          operationType: "check_coach_subscription",
          data: { coach_id: userId },
        });

        const data =
          typeof response.data.body === "string"
            ? JSON.parse(response.data.body)
            : response.data.body;

        // Directly access the correct values
        setCurrentPlan(data.subscription_type || "unknown"); // Adjusted to match backend response
        setFreeTierUsed(data.free_tier_used || false); // Boolean already converted
        setGamesLeft(data.games_left_this_month || 0); // No need for parseInt as backend sends number
        setSubscriptionStatus(data.subscription_status || "");
      } catch (err) {
        console.error("Error fetching subscription details:", err);
        setError("Failed to fetch subscription details.");
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptionDetails();
  }, [userId]);

  return (
    <div className="manage-subscription-container">
      <h2>Manage Your Subscription</h2>
      {loading ? (
        <div className="loading-container">
          <div className="football-spinner"></div>
          <p>Loading subscription details...</p>
        </div>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <div>
          <p>
            Your current plan: <strong>{currentPlan}</strong>
          </p>
          <p>
            Subscription status: <strong>{subscriptionStatus}</strong>
          </p>
          <p>
            Games left this month: <strong>{gamesLeft}</strong>
          </p>
          <p>
            Free tier used: <strong>{freeTierUsed ? "Yes" : "No"}</strong>
          </p>

          {currentPlan === "free" || currentPlan === "past_customer" ? (
            <PricingTable userId={userId} />
          ) : (
            <button
              onClick={() => {
                window.open(
                  "https://billing.stripe.com/p/login/cN201u6cC803bL2cMM",
                  "_blank"
                );
                navigate("/"); // Redirect to home page after opening the billing portal
              }}
              className="customer-portal-button"
            >
              Manage Subscription
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ManageSubscription;
